'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = AjaxReq;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _xhr = require('xhr');

var _xhr2 = _interopRequireDefault(_xhr);

function AjaxReq(url, reqContent) {
  var method = arguments.length <= 2 || arguments[2] === undefined ? 'POST' : arguments[2];

  return new Promise(function (resolve, reject) {
    (0, _xhr2['default'])({
      url: url,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      method: method,
      body: reqContent
    }, function (err, resp, body) {
      // console.log('err', err);
      // console.log('resp', resp);
      // console.log('body', body);
      if (resp.statusCode === 200) {
        resolve(body);
      } else {
        reject(new Error(err));
      }
    });
  });
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9iYWJlL1dvcmsvdjIuZG91YmxlZy51bHRyYW5vaXIuY29tL2Fzc2V0cy9zY3JpcHRzL21vZHVsZXMvYWpheFJlcXVlc3QuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7cUJBRXdCLE9BQU87Ozs7bUJBRmYsS0FBSzs7OztBQUVOLFNBQVMsT0FBTyxDQUFDLEdBQUcsRUFBRSxVQUFVLEVBQWlCO01BQWYsTUFBTSx5REFBQyxNQUFNOztBQUM3RCxTQUFPLElBQUksT0FBTyxDQUFDLFVBQUMsT0FBTyxFQUFFLE1BQU0sRUFBRztBQUNyQywwQkFBSTtBQUNVLFNBQUcsRUFBRSxHQUFHO0FBQ1IsYUFBTyxFQUFDLEVBQUMsY0FBYyxFQUFFLG1DQUFtQyxFQUFDO0FBQzdELFlBQU0sRUFBQyxNQUFNO0FBQ2IsVUFBSSxFQUFFLFVBQVU7S0FDbkIsRUFDRyxVQUFDLEdBQUcsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFLOzs7O0FBSWpCLFVBQUksSUFBSSxDQUFDLFVBQVUsS0FBSyxHQUFHLEVBQUU7QUFDMUIsZUFBTyxDQUFDLElBQUksQ0FBQyxDQUFDO09BQ2hCLE1BQU07QUFDSixjQUFNLENBQUMsSUFBSSxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQztPQUMzQjtLQUNGLENBQ1IsQ0FBQTtHQUNQLENBQUMsQ0FBQTtDQUNGIiwiZmlsZSI6Ii9Vc2Vycy9iYWJlL1dvcmsvdjIuZG91YmxlZy51bHRyYW5vaXIuY29tL2Fzc2V0cy9zY3JpcHRzL21vZHVsZXMvYWpheFJlcXVlc3QuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeGhyIGZyb20gJ3hocic7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIEFqYXhSZXEodXJsLCByZXFDb250ZW50LCBtZXRob2Q9J1BPU1QnKSB7XG5cdHJldHVybiBuZXcgUHJvbWlzZSgocmVzb2x2ZSwgcmVqZWN0KT0+e1xuXHRcdHhocih7XG4gICAgICAgICAgICAgICAgdXJsOiB1cmxcbiAgICAgICAgICAgICwgICBoZWFkZXJzOntcIkNvbnRlbnQtVHlwZVwiOiBcImFwcGxpY2F0aW9uL3gtd3d3LWZvcm0tdXJsZW5jb2RlZFwifVxuICAgICAgICAgICAgLCAgIG1ldGhvZDptZXRob2RcbiAgICAgICAgICAgICwgICBib2R5OiByZXFDb250ZW50XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICAsICAgKGVyciwgcmVzcCwgYm9keSkgPT4ge1xuICAgICAgICAgICAgICAgICAgICAvLyBjb25zb2xlLmxvZygnZXJyJywgZXJyKTtcbiAgICAgICAgICAgICAgICAgICAgLy8gY29uc29sZS5sb2coJ3Jlc3AnLCByZXNwKTtcbiAgICAgICAgICAgICAgICAgICAgLy8gY29uc29sZS5sb2coJ2JvZHknLCBib2R5KTtcbiAgICAgICAgICAgICAgICAgICAgaWYgKHJlc3Auc3RhdHVzQ29kZSA9PT0gMjAwKSB7XG4gICAgICAgICAgICAgICAgICAgICAgIHJlc29sdmUoYm9keSk7XG4gICAgICAgICAgICAgICAgICAgXHR9IGVsc2Uge1xuICAgICAgICAgICAgICAgICAgICAgICByZWplY3QobmV3IEVycm9yKGVycikpO1xuICAgICAgICAgICAgICAgICBcdH1cbiAgICAgICAgICAgICAgICB9XG4gICAgICAgIClcblx0fSlcbn0iXX0=